<template>
  <Flex
    :class="$style.base"
    direction="column"
  >
    <BaseText>{{ $t('global.color') }}</BaseText>
    <BaseRadio
      v-model="colorOption"
      :label="$t('global.color')"
      :options="colorOptions"
      @update:modelValue="onColorOptionSelect"
      v-test="'colorOptions'"
    />
    <Flex
      direction="column"
      v-show="colorOption === 'other'"
      v-test="'colorPicker'"
    >
      <BaseHeading size="s">
        {{ $t('global.actions.select') }}
      </BaseHeading>
      <BaseColorLabel
        v-model="colorValue"
        colorPicker
        isSelected
      />
    </Flex>
  </Flex>
</template>

<script lang="ts">
import { mapState, storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../store';

export default defineComponent({
  data() {
    return {
      colorOption: 'booking_widget',
    };
  },
  setup() {
    const { id, color } = storeToRefs(useMarketingStore());
    return {
      id,
      color,
    };
  },
  watch: {
    colorOption() {
      if (this.colorOption === 'booking_widget') {
        this.setDefaultColor();
      }
    },
    colorValue(value) {
      if (!value || value === this.defaultColor) {
        this.colorOption = 'booking_widget';
      }
    },
  },
  computed: {
    colorOptions() {
      return [
        {
          label: this.$t('global.booking_widget'),
          value: 'booking_widget',
        },
        {
          label: this.$t('marketing.email.sections.another_color'),
          value: 'other',
        },
      ];
    },
    ...mapState(useCompanyStore, ['company', 'companySettings']),
    colorValue: {
      get() {
        return this.color;
      },
      set(value: string) {
        this.color = value;
      },
    },
    defaultColor(): string {
      const { customColor, primaryColor } = this.companySettings.bookingWidget;
      if (primaryColor === 'main') {
        return '#FF6575';
      } else if (primaryColor === 'dark') {
        return '#404043';
      } else {
        return customColor;
      }
    },
  },
  methods: {
    onColorOptionSelect(value: string) {
      this.colorOption = value;
    },
    setDefaultColor() {
      this.color = this.defaultColor;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.id && this.color && this.color !== this.defaultColor) {
        this.colorOption = 'other';
        return;
      }

      this.setDefaultColor();
    });
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  padding-bottom: $spacing;
}
</style>
